import { message } from '@/utils/wuji-message';
import { requestCgi } from '@tencent/wuji-source';
import { computed, onMounted, ref } from '@vue/composition-api';
import { cloneDeep } from 'lodash';
export function useDepartmentTree(groupId) {
    const departmentList = ref([]);
    const fetchDepartments = async () => {
        try {
            // 请求数据源，混乱...
            const { body } = await requestCgi('departments', 'list', {
                query: {
                    page: 1,
                    size: 15000,
                },
            }, {
                projectId: `${groupId}_organization`,
                envId: 'prod',
                pageId: 'user',
            });
            if (body.code === 0) {
                departmentList.value = body.data;
            }
            else {
                message.error(body.message);
            }
        }
        catch (error) {
            console.error(error);
            message.error('获取部门列表失败,请确认是否初始化组织架构');
        }
    };
    const departmentTree = computed(() => {
        const departments = cloneDeep(departmentList.value);
        // 获取部门id-map
        const departmentsMap = {};
        departments.forEach((department) => {
            departmentsMap[department.id] = department;
        });
        departments.forEach((department) => {
            if (department.parentId && departmentsMap?.[department.parentId]) {
                if (departmentsMap[department.parentId].children) {
                    departmentsMap[department.parentId].children.push(department);
                }
                else {
                    departmentsMap[department.parentId].children = [department];
                }
            }
        });
        // 没有 parentId 表示为根部门
        return departments.filter(department => !department.parentId);
    });
    const departmentTreeSelectData = computed(() => {
        const oTree = departmentTree.value;
        const walk = (node) => {
            const { id, name, children } = node;
            const option = {
                value: id,
                label: name,
            };
            if (children?.length) {
                option.children = children.map(walk);
            }
            return option;
        };
        const optionTree = oTree.map(walk);
        return optionTree;
    });
    onMounted(() => {
        fetchDepartments();
    });
    return {
        departmentList,
        departmentTree,
        departmentTreeSelectData,
    };
}
